// extracted by mini-css-extract-plugin
export default {"special-text":"NameTemplate_special-text__lUQqT"};